import { PermissionTypes } from '@/constants/permissions'
import { MenuLinks } from '@/constants/menu'
import { usePermission, useAnyPermissions } from '@/hooks/usePermission'
import { RootState } from '@/redux/store'
import Preloader from '@/components/Preloader'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

type Props = {
	children: React.ReactNode
	/** Single permission or any-of list. */
	permission: PermissionTypes | PermissionTypes[]
	/** Where to send unauthorized users. Defaults to access-denied. */
	redirectTo?: string
}

/**
 * Route-level gate: waits for auth permissions to load, then requires the given claim(s).
 */
const PermissionGuard = ({ children, permission, redirectTo = '/access-denied' }: Props) => {
	const { userHasPermission } = usePermission()
	const { hasAnyPermissions } = useAnyPermissions()
	const permissionsLoaded = useSelector((state: RootState) => state.Auth.permissionsLoaded)

	if (!permissionsLoaded) {
		return <Preloader />
	}

	const allowed = Array.isArray(permission) ? hasAnyPermissions(permission) : userHasPermission(permission)

	if (!allowed) {
		return <Navigate to={redirectTo || MenuLinks.Dashboard} replace />
	}

	return <>{children}</>
}

export default PermissionGuard
